import { EFormEntityType } from '@/interfaces'
import SubsectionDefault from './default'
import SubsectionTable from './table'
import { FormState } from '@/state'
import { FormInstance } from 'antd'

export default function RenderEntityForm({ form }: { form: FormInstance }) {
  if (!FormState.currentEntity.value?.permission?.read) return null

  if (FormState.currentEntity.value?.type === EFormEntityType.TABLE) {
    return <SubsectionTable />
  }

  return <SubsectionDefault form={form} />
}
